'use client';
import './ImageBox.css';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip/index.js';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import { useSortable } from '@dnd-kit/sortable';

interface ImageBoxProps {
	url: string;
	position: number | null;
	isReadOnly?: boolean;
	isCircle?: boolean;
	isDraggable?: boolean;
	onEditImage?: () => void;
	onRemoveImage?: () => void;
	onSeeFullscreenImage?: () => void;
	t?: any;
}

const ImageBox = ({
	url,
	position,
	isReadOnly = false,
	isCircle = false,
	isDraggable = false,
	onEditImage,
	onRemoveImage,
	onSeeFullscreenImage,
	t,
}: ImageBoxProps) => {
	const { attributes, listeners } = useSortable({
		id: isDraggable && !isReadOnly ? position! : 0,
	});

	return (
		<div
			className={`image-box${isCircle ? ' image-box--circle' : ''}${
				isReadOnly ? ' image-box--read-only' : ''
			}`}
		>
			<div className='image-box__image-preview-wrapper'>
				<img className='image-box__image-preview' src={url} />
				{!isReadOnly && onSeeFullscreenImage != null && (
					<div className='image-box__see-overlay' onClick={onSeeFullscreenImage}></div>
				)}
			</div>
			{!isReadOnly && (
				<div className='image-box__image-buttons'>
					{isDraggable && (
						<SlTooltip
							content={t == null ? 'Riordina' : t('Sort')}
							placement='right'
							distance={-5}
							className='image-box__button-tooltip'
						>
							<SlButton
								className='image-box__sort-image'
								circle
								{...listeners}
								{...attributes}
							>
								<SlIcon name='arrows-move' />
							</SlButton>
						</SlTooltip>
					)}
					{onEditImage != null && (
						<SlTooltip
							content={t == null ? 'Modifica' : t('Edit')}
							placement='right'
							distance={-5}
							className='image-box__button-tooltip'
						>
							<SlButton
								className='image-box__edit-image'
								onClick={onEditImage}
								circle
							>
								<SlIcon name='pencil' />
							</SlButton>
						</SlTooltip>
					)}
					<SlTooltip
						content={t == null ? 'Rimuovi' : t('Remove')}
						placement='right'
						distance={-5}
						className='image-box__button-tooltip'
					>
						<SlButton
							className='image-box__remove-image'
							onClick={onRemoveImage}
							circle
						>
							<SlIcon name='trash3' />
						</SlButton>
					</SlTooltip>
				</div>
			)}
		</div>
	);
};

export { ImageBox };
